import React, { createContext, useContext, useRef, useEffect } from 'react';
import { Animated } from 'react-native';

interface OnboardingProgressContextType {
  progressAnim: Animated.Value;
  setProgress: (width: number) => void;
}

const OnboardingProgressContext = createContext<OnboardingProgressContextType | null>(null);

export function OnboardingProgressProvider({ children }: { children: React.ReactNode }) {
  const progressAnim = useRef(new Animated.Value(0)).current;

  const setProgress = (width: number) => {
    Animated.timing(progressAnim, {
      toValue: width,
      duration: 300,
      useNativeDriver: false,
    }).start();
  };

  return (
    <OnboardingProgressContext.Provider value={{ progressAnim, setProgress }}>
      {children}
    </OnboardingProgressContext.Provider>
  );
}

export function useOnboardingProgress() {
  const context = useContext(OnboardingProgressContext);
  if (!context) {
    throw new Error('useOnboardingProgress must be used within OnboardingProgressProvider');
  }
  return context;
}
